import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer style={{background: '#1e3a8a', color: 'white'}}>
      {/* Main Footer */}
      <div style={{
        maxWidth: '1200px',
        margin: '0 auto',
        padding: '4rem 2rem 2rem',
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
        gap: '3rem'
      }}>
        {/* Company Info */}
        <div>
          <div style={{
            fontSize: '1.8rem',
            fontWeight: '900',
            marginBottom: '1rem',
            display: 'flex',
            alignItems: 'center',
            gap: '0.75rem'
          }}>
            <span style={{fontSize: '2.5rem'}}>📋</span>
            <span>Ursus Victor LLC</span>
          </div>
          <p style={{fontSize: '1rem', lineHeight: '1.7', opacity: 0.9, marginBottom: '1.5rem'}}>
            Professional loan application support and documentation services.
          </p>
          <p style={{fontSize: '0.95rem', opacity: 0.85, fontWeight: '600'}}>
            ⚠️ We are NOT a lender
          </p>
        </div>

        {/* Quick Links */}
        <div>
          <h3 style={{fontSize: '1.3rem', fontWeight: '800', marginBottom: '1.25rem'}}>
            Quick Links
          </h3>
          <div style={{display: 'flex', flexDirection: 'column', gap: '0.75rem'}}>
            <Link to="/" style={{color: 'white', opacity: 0.9, fontSize: '1rem'}}>Home</Link>
            <Link to="/about" style={{color: 'white', opacity: 0.9, fontSize: '1rem'}}>About Us</Link>
            <Link to="/services" style={{color: 'white', opacity: 0.9, fontSize: '1rem'}}>Services</Link>
            <Link to="/resources" style={{color: 'white', opacity: 0.9, fontSize: '1rem'}}>Resources</Link>
            <Link to="/faq" style={{color: 'white', opacity: 0.9, fontSize: '1rem'}}>FAQ</Link>
            <Link to="/contact" style={{color: 'white', opacity: 0.9, fontSize: '1rem'}}>Contact</Link>
          </div>
        </div>

        {/* Services */}
        <div>
          <h3 style={{fontSize: '1.3rem', fontWeight: '800', marginBottom: '1.25rem'}}>
            Our Services
          </h3>
          <div style={{display: 'flex', flexDirection: 'column', gap: '0.75rem'}}>
            <Link to="/services/application-support" style={{color: 'white', opacity: 0.9, fontSize: '1rem'}}>
              Application Assistance
            </Link>
            <Link to="/services/document-preparation" style={{color: 'white', opacity: 0.9, fontSize: '1rem'}}>
              Document Preparation
            </Link>
            <div style={{color: 'white', opacity: 0.9, fontSize: '1rem'}}>Application Review</div>
            <div style={{color: 'white', opacity: 0.9, fontSize: '1rem'}}>Submission Guidance</div>
          </div>
        </div>

        {/* Contact */}
        <div>
          <h3 style={{fontSize: '1.3rem', fontWeight: '800', marginBottom: '1.25rem'}}>
            Contact Us
          </h3>
          <div style={{display: 'flex', flexDirection: 'column', gap: '1rem', fontSize: '1rem'}}>
            <div>
              <div style={{fontWeight: '700', marginBottom: '0.25rem'}}>Email:</div>
              <a href="mailto:support@ursusconnects.com" style={{color: '#93c5fd', opacity: 0.95}}>
                support@ursusconnects.com
              </a>
            </div>
            <div>
              <div style={{fontWeight: '700', marginBottom: '0.25rem'}}>General Inquiries:</div>
              <a href="mailto:info@ursusconnects.com" style={{color: '#93c5fd', opacity: 0.95}}>
                info@ursusconnects.com
              </a>
            </div>
            <div>
              <div style={{fontWeight: '700', marginBottom: '0.25rem'}}>Hours:</div>
              <div style={{opacity: 0.9}}>Mon-Fri: 9 AM - 6 PM EST</div>
            </div>
          </div>
        </div>
      </div>

      {/* Legal Links */}
      <div style={{
        borderTop: '1px solid rgba(255,255,255,0.2)',
        padding: '2rem',
        marginTop: '2rem'
      }}>
        <div style={{
          maxWidth: '1200px',
          margin: '0 auto',
          display: 'flex',
          justifyContent: 'center',
          flexWrap: 'wrap',
          gap: '2rem',
          fontSize: '0.95rem'
        }}>
          <Link to="/privacy" style={{color: 'white', opacity: 0.85}}>Privacy Policy</Link>
          <Link to="/terms" style={{color: 'white', opacity: 0.85}}>Terms of Service</Link>
          <Link to="/sms-policy" style={{color: 'white', opacity: 0.85}}>SMS Policy</Link>
          <Link to="/cookie-policy" style={{color: 'white', opacity: 0.85}}>Cookie Policy</Link>
          <Link to="/sms-consent" style={{color: 'white', opacity: 0.85}}>SMS Consent</Link>
        </div>
      </div>

      {/* Disclaimer */}
      <div style={{
        background: '#172554',
        padding: '2rem',
        textAlign: 'center'
      }}>
        <p style={{fontSize: '0.95rem', opacity: 0.9, lineHeight: '1.7', maxWidth: '1000px', margin: '0 auto 1rem'}}>
          <strong>IMPORTANT:</strong> Ursus Victor LLC provides loan application support and documentation services only. 
          We are NOT a lender, do NOT make loans, and do NOT make lending decisions. We do NOT guarantee loan approval. 
          All lending decisions are made solely by financial institutions.
        </p>
        <p style={{fontSize: '0.9rem', opacity: 0.8}}>
          © {currentYear} Ursus Victor LLC. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
